// Format unix timestamp to LinkedIn-style date: "Jul 2024 - Present" or "Jul 2024 - Dec 2024"
export const formatDate = (unixTimestamp, fallback = "") =>
  unixTimestamp
    ? new Date(unixTimestamp * 1000).toLocaleDateString("en-GB", {
        month: "short",
        year: "numeric",
      })
    : fallback;
